import React, { useEffect, useRef, useState } from "react";
import style from "../../PagesStyles/Heading.module.css";
import smallLogo from "../../../Images/loyalStringLogoSmall.png";
import Loyal_logo_white from "../../../Images/Loyal_logo_white.png";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

import { useNavigate } from "react-router-dom";
import ResponsiveDrawer from "./ResponsiveDrawer";
import { useDispatch, useSelector } from "react-redux";
import { adminLoggedOut } from "../../../../redux/action/Actions";

export default function AdminTopNavbar() {
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;


  
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;

  const FirstName = adminLoggedIn.FirstName;
  const LastName=  adminLoggedIn.LastName;

  console.log('check user data', adminLoggedIn);
  


  const [settingsPanelOpen, setSettingsPanelOpen] = useState(false);
  const [drawerSection, setDrawerSection] = useState("Settings");
  const [isDarkMode, setIsDarkMode] = useState(false);

  const [dropdownOpen, setDropdownOpen] = useState(false);


  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  
  const handleChange = () => {
    setIsDarkMode(!isDarkMode);
    // Call a function to switch the entire app's theme to light/dark mode here
  };
  const toggleDrawer = () => {
    setSettingsPanelOpen(!settingsPanelOpen);
  };
  const [isFullScreen, setIsFullScreen] = useState(false);

  const dropdownRef = useRef(null);
  const dropdown2Ref = useRef(null);
  const dropdown3Ref = useRef(null);
  const dropdown4Ref = useRef(null);
  const dropdown5Ref = useRef(null);
  const dropdown6Ref = useRef(null);

  const [isAnimating, setIsAnimating] = useState(false);

  const handleFullScreen = () => {
    if (!isFullScreen) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        dropdown2Ref.current &&
        !dropdown2Ref.current.contains(event.target) &&
        dropdown3Ref.current &&
        !dropdown3Ref.current.contains(event.target) &&
        dropdown4Ref.current &&
        !dropdown4Ref.current.contains(event.target) &&
        dropdown5Ref.current &&
        !dropdown5Ref.current.contains(event.target) &&
        dropdown6Ref.current &&
        !dropdown6Ref.current.contains(event.target)
      ) {
        setDropdown(false);
        setDropdown2(false);
        setDropdown3(false);
        setDropdown4(false);
        setDropdown5(false);
        setDropdown6(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const categories = [
    {
      id: 1,
      name: "Organization", //User Master
      items: [
        { id: 1, name: "Company", linkto: "/add_company_new" },///add_company
        { id: 2, name: "Branch", linkto: "/add_branch_new" },///add_branch
        { id: 3, name: "Counter", linkto: "/add_counter_new" }, ///add_counter
        { id: 4, name: "Department", linkto: "/add_department_new" }, ///add_department
        { id: 5, name: "Roles", linkto: "/add_roles_new" }, ///add_roles
        // { id: 6, name: "Employees", linkto: "/add_employees" },
        { id: 7, name: "Bank", linkto: "/add_banks_new" }, ///add_banks
        { id: 8, name: "Devices", linkto: "/add_devices_new" }, ///add_devices
        { id: 9, name: "Tax", linkto: "/add_tax_new" }, ///add_tax
        { id: 10, name: "Rate Conversion", linkto: "/add_rate_new" }, ///add_rate
        // { id: 9, name: "ActivityLog", linkto: "/add_rates" },
        // { id: 10, name: "UserLog", linkto: "/add_rates" },
        // { id: 11, name: "Access Request Log", linkto: "/add_rates" },
        // //{ id: 12, name: "Making", linkto: "/adminhome" },
        // { id: 16, name: "Bank", linkto: "/adminhome" },
      ],
    },
    {
      id: 2,
      name: "Create Product", //Products Master
      items: [
        { id: 1, name: "Category", linkto: "/add_category_new" }, ///add_category
        { id: 2, name: "Product", linkto: "/add_product_new" }, ///add_product
        { id: 3, name: "Design", linkto: "/add_design_new" }, ///add_design
        { id: 4, name: "Purity", linkto: "/add_purity_new" }, ///add_purity
        { id: 5, name: "Packet", linkto: "/add_packet_new" }, ///add_packet
        { id: 6, name: "Box", linkto: "/add_box_new" }, ///add_box
        { id: 7, name: "Stone", linkto: "/add_stone_new" },///add_stone
        // { id: 7, name: "Diamond", linkto: "/add_diamond" },
        {
          id: 8,
          name: "Diamond Size/Weight/Rate ",
          linkto: "/add_daimond_new",   ///add_diamond_size_weight_rate
        },
        { id: 9, name: "SKU", linkto: "/add_sku_new" }, ///add_sku
        { id: 10, name: "Rates", linkto: "/add_rates_new" }, ///add_rates
        { id: 11, name: "Collection", linkto: "/add_collection_new" }, ///add_collection
        // { id: 12, name: "Occassion", linkto: "/add_occassion" },
        // {id: 13, name: "Diamond Size/Weight/Rate/Template", linkto: "/"}

        // { id: 11, name: "Party", linkto: "/add_vendor" },
        // //{ id: 12, name: "Making", linkto: "/adminhome" },
        // { id: 16, name: "Bank", linkto: "/adminhome" },
      ],
    },
    {
      id: 3,
      name: "Transactions", //Trading
      items: [
        { id: 1, name: "Purchase Entry", linkto: "/purchase_entry_new" }, ///purchase_entry
        // { id: 9, name: "Create Packet", linkto: "/create_packet" },
        { id: 2, name: "Add Bulk Stock New", linkto: "/add_bulk_stock_new" },
        { id: 0, name: "Add Single Stock", linkto: "/add_single_stock" },
        { id: 4, name: "Invoice", linkto: "/admin_invoice" }, //admin_invoice
        // { id: 5, name: "Make Payments", linkto: "/purchase_payments" },
        // { id: 6, name: "Recieve Payments", linkto: "/receive_payments" },
        // { id: 7, name: "Credit Note / Sale Return", linkto: "/credit_note" },
        // { id: 8, name: "Debit Note / Purchase Return", linkto: "/debit_note" },
        // { id: 15, name: "Stock Transfer", linkto: "/stock_transfer" },
        // { id: 14, name: "Stock Transfer List", linkto: "/stock_transfer_list" },
      ],
    },
    {
      id: 4,
      name: "Reports",
      items: [
        { id: 1, name: "Stock", linkto: "/stock_report" },
        // {id: 0, name: "SKU Report", linkto: "/admin_sku_report"},
        // {
        //     id: 10,
        //     name: "Sku / Karigar Report",
        //     linkto: "/admin_sku_karigar_wise_report",
        // },
        // {id: 2, name: "Inventory", linkto: "/inventory"},
        { id: 3, name: "Sale", linkto: "/admin_sale_report" },
        { id: 4, name: "Order List", linkto: "/admin_orders" },
        { id: 5, name: "Purchase", linkto: "/purchase" },
        { id: 6, name: "Customer Ledger", linkto: "/admin_customer_ledger" },
        { id: 7, name: "Supplier Ledger", linkto: "/admin_vendor_ledger" },
        { id: 8, name: "Old Metal", linkto: "/purchase" },
        { id: 9, name: "Cash", linkto: "/cash_report" },
        // {id: 10, name: "allReport", linkto: "/all_Report"},

        // {
        //   id: 10,
        //   name: "Invoice Customisaton",
        //   linkto: "/invoice_customisation",
        // },
        // { id: 29, name: "Old Metal", linkto: "/adminhome" },
        // { id: 30, name: "GST", linkto: "/adminhome" },
      ],
    },
    // {
    //   id: 4,
    //   name: "E-Commerce",
    //   icon: "<AiOutlineShoppingCart/>",
    //   items: [
    //     { id: 3, name: "Customer", linkto: "/add_customer" },
    //     { id: 7, name: "Category New", linkto: "/category_new" },

    //     // { id: 5, name: "Refresh Products", linkto: "/reloadproducts" },
    //     // { id: 5, name: "New List", linkto: "/admin-newlist" },
    //     // { id: 2, name: "Add Product", linkto: "/admin-addproduct" },
    //   ],
    // },

    // {
    //   id: 3,
    //   name: "Master",
    //   items: [
    //     // { id: 6, name: "Category", linkto: "/add_category" },
    //     // { id: 7, name: "Product", linkto: "/add_product_type" },
    //     // { id: 8, name: "Collection", linkto: "/add_collection" },
    //     // { id: 9, name: "Purity", linkto: "/add_purity" },
    //     // { id: 45, name: "Rates", linkto: "/add_rates" },
    //     { id: 10, name: "Stone", linkto: "/add_stone" },
    //     { id: 11, name: "SKU", linkto: "/add_sku" },
    //     //{ id: 12, name: "Making", linkto: "/adminhome" },
    //     { id: 13, name: "Box", linkto: "/add_box" },
    //     { id: 14, name: "Supplier", linkto: "/add_supplier" },
    //     { id: 15, name: "Employee", linkto: "/add_employee" },
    //     // { id: 16, name: "Bank", linkto: "/adminhome" },
    //   ],
    // },

    // {
    //   id: 4,
    //   name: "Accounts",
    //   items: [
    //     { id: 17, name: "Ledger", linkto: "/ledger_main" },
    //     { id: 18, name: "Voucher", linkto: "/adminhome" },
    //     { id: 19, name: "Statement", linkto: "/adminhome" },
    //     { id: 20, name: "Day Book", linkto: "/adminhome" },
    //     { id: 21, name: "Trial Balance", linkto: "/adminhome" },
    //     { id: 22, name: "Profit & Loss", linkto: "/adminhome" },
    //     { id: 23, name: "Balance Sheet", linkto: "/adminhome" },
    //   ],
    // },

    // {
    //   id: 6,
    //   name: "Gold Scheme",
    //   items: [
    //     { id: 31, name: "Create", linkto: "/adminhome" },
    //     { id: 32, name: "Enroll", linkto: "/adminhome" },
    //     { id: 33, name: "Installment", linkto: "/adminhome" },
    //     { id: 34, name: "Collection", linkto: "/adminhome" },
    //     { id: 35, name: "Pending", linkto: "/adminhome" },
    //     { id: 36, name: "Maturity", linkto: "/adminhome" },
    //   ],
    // },
    // {
    //   id: 7,
    //   name: "Loan",
    //   items: [
    //     { id: 37, name: "Issue", linkto: "/adminhome" },
    //     { id: 38, name: "Receipt", linkto: "/adminhome" },
    //     { id: 39, name: "Capital", linkto: "/adminhome" },
    //   ],
    // },
    // {
    //   id: 8,
    //   name: "CRM",
    //   items: [
    //     { id: 40, name: "Dashbord", linkto: "/adminhome" },
    //     { id: 41, name: "Contacts", linkto: "/adminhome" },
    //     { id: 42, name: "Opportunities", linkto: "/adminhome" },
    //     { id: 43, name: "Leads", linkto: "/adminhome" },
    //     { id: 44, name: "Customers", linkto: "/adminhome" },
    //   ],
    // },
    {
      id: 9,
      name: "Settings",
      items: [
        { id: 45, name: "Vendor Tounche", linkto: "/vendor_tounche_new" }, ///vendor_tounche
        { id: 46, name: "Customer Tounche", linkto: "/customer_tounche_new" }, ///customer_tounche
        {
          id: 47,
          name: "Diamond Attributes",
          linkto: "/diamond_attribute_new", ///add_diamond_attributes
        },
        {
          id: 48,
          name: "Pair Customer Vendor",
          linkto: "/pair_customer_vendor_new", ///pair_customer_vendor
        },
        { id: 49, name: "Customer Slab", linkto: "/customer_slab_new" },///customer_slab
        {
          id: 50,
          name: "Customer Rate Of Interest",
          linkto: "/customer_rate_of_interest_new", ///customer_rate_of_interest
        },
        {
          id: 51,
          name: "Customer Credit Period",
          linkto: "/customer_credit_period_new", ///customer_credit_period
        },
        {
          id: 51,
          name: "User Management",
          linkto: "/user-management",
        },
        // { id: 45, name: "Rates", linkto: "/add_rates" },
        // { id: 46, name: "Offers", linkto: "/adminhome" },
        // { id: 47, name: "Discount", linkto: "/adminhome" },
        // { id: 48, name: "Points", linkto: "/adminhome" },
        // { id: 49, name: "Company", linkto: "/adminhome" },
        // { id: 50, name: "Branch", linkto: "/adminhome" },
        // { id: 51, name: "Year", linkto: "/adminhome" },
        // { id: 52, name: "User", linkto: "/adminhome" },
      ],
    },
    // Add more categories as needed
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    // Perform any additional logout actions if needed
    // ...
    // Dispatch the logout action
    dispatch(adminLoggedOut());
    navigate("/adminpanellogin");
  };

  const mobileDrawer = [
    {
      id: 0,
      name: "Create New",
      items: [
        { id: 1, name: "Add Customer", linkto: "/add_customer_new" },///add_customer
        { id: 2, name: "Add Vendor", linkto: "/add_vendor_new" }, ///add_vendor
        { id: 2, name: "Add Employee", linkto: "/add_employee_new" }, ///add_employees
      ],
    },
    ...categories,
  ];

  const [activeMenu, setActiveMenu] = useState(null);
  const menuRef = useRef(null);

  const handleMenuClick = (menu) => {
    if (activeMenu === menu) {
      setIsAnimating(true);
      setTimeout(() => {
        setActiveMenu(null);
        setIsAnimating(false);
      }, 300); // Match the duration of the CSS transition
    } else {
      setActiveMenu(menu);
    }
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsAnimating(true);
      setTimeout(() => {
        setActiveMenu(null);
        setIsAnimating(false);
      }, 300); // Match the duration of the CSS transition
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const menuItems = {
    "Create Member": [
      { label: "Customer", link: "/add_customer_new" },
      { label: "Vendor", link: "/add_vendor_new" },
      { label: "Employee", link: "/add_employee_new" },
    ],
    "Create Product":[
      { label: "Category", link: "/add_category_new" },
      { label: "Product", link: "/add_product_new" },
      { label: "Design", link: "/add_design_new" },
      { label: "Purity", link: "/add_purity_new" },
      { label: "Packet", link: "/add_packet_new" },
      { label: "Box", link: "/add_box_new" },
      { label: "Stone", link: "/add_stone_new" },
      { label: " Diamond Size/Weight/Rate", link: "/add_daimond_new" },
      { label: "SKU", link: "/add_sku_new" },
      { label: "Rates", link: "/add_rates_new" },
      { label: "Collection", link: "/add_collection_new" },
    ],
    Transactions: [
      { label: "Purchase Entry", link: "/purchase_entry_new" },
      // { label: "Create Packet", link: "/create_packet" },
      { label: "Add Bulk Stock New", link: "/add_bulk_stock_new" },
      { label: "Add Single Stock", link: "/add_single_stock" },
      { label: "Invoice", link: "/invoice_entry_new" }, //admin_invoice

      // { label: "Recieve Payments", link: "/receive_payments" },
      // { label: " Stock Transfer", link: "/stock_transfer" },
    ],
    Reports: [
      { label: "Stock", link: "/stock_report" },
      { label: "Sale", link: "/admin_sale_report" },
      { label: "Order List", link: "/admin_orders" },
      { label: "Purchase", link: "/purchase" },
      { label: " Customer Ledger", link: "/admin_customer_ledger" },
      { label: "Supplier Ledger", link: "/admin_vendor_ledger" },
      { label: "Old Metal", link: "/purchase" },
      { label: "Cash", link: "/cash_report" },
    ],
    Organization:[
      { label: "Company", link: "/add_company_new" },
      { label: "Branch", link: "/add_branch_new" },
      { label: "Counter", link: "/add_counter_new" },
      { label: "Department", link: "/add_department_new" },
      { label: "Roles", link: "/add_roles_new" },
      // { label: "Employees", link: "/user-reports" },
      { label: "Bank", link: "/add_banks_new" },
      { label: "Devices", link: "/add_devices_new" },
      { label: "Tax", link: "/add_tax_new" },
      { label: "Rate Conversion", link: "/add_rate_new" },
    ],
    Setting: [
      { label: "Vendor Tounche", link: "/vendor_tounche_new" },
      { label: " Customer Tounche", link: "/customer_tounche_new" },
      { label: "Pair Customer Vendor", link: "/pair_customer_vendor_new" },
      { label: "Diamond Attribute", link: "/add_diamond_attributes" },
      { label: "Stone Attribute", link: "/add_stone_attributes" },
      { label: "Customer Slab", link: "/customer_slab_new" },
      { label: "Customer Rate Of Interest", link: "/customer_rate_of_interest_new" },
      { label: " Customer Credit Period", link: "/customer_credit_period_new" },
      { label: " User Management", link: "/user-management" },
      { label: " Bill Formates", link: "/user-billformates" },
    ],
  };

  return (
    <nav className={style.navbarDesktopMainOuterBox} style={{zIndex:"20"}}>
      <div className={style.navbarDesktopMainInnerBox}>
        <div className={style.navbarDesktopMainLeftBox}>
          <div className={style["inner-left-box"]}>
            <img
              className={style["companyLogoLarge"]}
              // src={wideLogo}
              onClick={() => navigate("/adminhome")}
              style={{ width: "175px", height: "24px", cursor: "pointer" }}
              src={Loyal_logo_white}
              alt="companyLogoWide"
            />

            <div className={style["container-menus"]} ref={menuRef}>
              {Object.keys(menuItems).map((menu, index) => (
                <div key={index} className={style["menu-wrapper"]}>
                  <a
                    href="#"
                    className={style["menu-items"]}
                    onClick={(e) => {
                      e.preventDefault();
                      handleMenuClick(menu);
                    }}
                  >
                    {menu}
                    <Icon
                      icon={
                        activeMenu === menu
                          ? "mdi:chevron-up"
                          : "mdi:chevron-down"
                      }
                      className={style["menu-icon"]}
                    />
                  </a>
                  <div
                    className={`${style.dropdown} ${
                      activeMenu === menu
                        ? style.open
                        : isAnimating
                        ? style.close
                        : ""
                    }`}
                  >
                    {menuItems[menu].map((item, subIndex) => (
                      <Link
                        key={subIndex}
                        to={item.link} // Use the individual link here
                        className={style["dropdown-item-head"]}
                        onClick={() => {
                          setIsAnimating(true);
                          setTimeout(() => {
                            setActiveMenu(null);
                            setIsAnimating(false);
                          }, 300);
                        }}
                      >
                        {item.label}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={style["adminPanelCompanyLogoMobile"]}>
            <img
              onClick={() => navigate("/adminhome")}
              className={style["companyLogoSmall"]}
              src={smallLogo}
              alt="companyLogoSmall"
            />
            {/* <h3
              style={{ whiteSpace: "nowrap" }}
              className={
                style["comapanysNameHeading adminPanelCompanyLogoMobile"]
              }
              onClick={() => navigate("/adminhome")}
            >
              LOYAL STRING
            </h3> */}
          </div>

          <div className={style["mobileDrawerMainBox"]}>
            <ResponsiveDrawer
             categories={mobileDrawer} 
            handleLogout={handleLogout}
            adminLoggedIn={adminLoggedIn}
            />
          </div>
        </div>
        {/* Searchbar Below */}
        <div className={style["navbarDesktopMainRightBox"]}>
          <Icon
            style={{ cursor: "pointer" }}
            onClick={handleFullScreen}
            width="24px"
            icon="material-symbols:fullscreen"
          />
          {/* <div style={{display: 'flex', gap: '5px', alignItems: 'center'}}>
          <Icon width="24px" icon="flowbite:user-circle-outline" />
          <h3 className={style["user-name"]}>Utkarsh Pathak</h3>
          </div> */}

<div className={style.container} ref={dropdownRef}>
      <div className={ dropdownOpen ? style["userInfo-open"] : style.userInfo} onClick={toggleDropdown}>
      <Icon width="24px" icon="flowbite:user-circle-outline" />
        <h3 className={style["user-name"]}>{FirstName}{LastName}</h3>
      </div>
      {dropdownOpen && (
        <div className={style.dropdownMenu}>
          <div className={style.dropdownItem} onClick={handleLogout}>
          <Icon icon="ri:logout-circle-line" width="24" height="24" />
            <span>Logout</span>
          </div>
        </div>
      )}
    </div>
         
          <Icon width="24px" icon="lsicon:apps-outline" />
        </div>
      </div>
    </nav>
  );
}
